/**
 * Bundle Monaco locally instead of fetching it from a CDN at runtime.
 *
 * @monaco-editor/react defaults to loading the editor from jsdelivr. A college
 * lab behind a proxy or with no internet would get a permanently blank editor,
 * so we ship the code ourselves.
 *
 * Import paths go through monaco's exports map ("./*" -> "./esm/vs/*.js"), so
 * they are written as monaco-editor/editor/... not monaco-editor/esm/vs/...
 */
import { loader } from "@monaco-editor/react";
import * as monaco from "monaco-editor/editor/editor.api";
import EditorWorker from "monaco-editor/editor/editor.worker?worker";

// C needs no language server; the basic-languages grammars give syntax
// highlighting and bracket matching, which is what a lab editor requires.
// 0.56 ships these as one contribution module that registers grammars lazily.
// Skipping the TypeScript/JSON/HTML language services keeps the heavy parts out.
import "monaco-editor/basic-languages/monaco.contribution";

self.MonacoEnvironment = {
  getWorker() {
    return new EditorWorker();
  },
};

loader.config({ monaco });
